/**
 * Device cache of Project Tasks (read-only offline copy).
 *
 * Tasks 1.0 offline scope: tasks of a project are cached whenever they are
 * loaded online and whenever a Favorite's offline package is prepared, so a
 * Ready-offline project shows its tasks without a connection. Changes
 * (create / edit / complete / delete) need a connection in 1.0 — see
 * docs/engineering/offline_reference.md.
 *
 * Org-scoped (orgCacheStorage) and cleared with the other scoped caches on
 * sign-out / user switch.
 */
import { readOrgScopedJson, writeOrgScopedJson } from "../orgCacheStorage";

export const PROJECT_TASKS_CACHE_KEY = "CP_PROJECT_TASKS_V1";

function orgId(actor) {
  return actor?.organization_id || null;
}

function readAll(actor) {
  try {
    const value = readOrgScopedJson(PROJECT_TASKS_CACHE_KEY, orgId(actor));
    return value && typeof value === "object" ? value : {};
  } catch {
    return {};
  }
}

export function rememberProjectTasks(actor, projectId, tasks) {
  if (!projectId) return;
  try {
    const all = readAll(actor);
    all[projectId] = { savedAt: new Date().toISOString(), tasks: tasks || [] };
    writeOrgScopedJson(PROJECT_TASKS_CACHE_KEY, orgId(actor), all);
  } catch {
    // Storage full / blocked: the online copy is still authoritative.
  }
}

/** Cached tasks for a project, or null when this device has none. */
export function readCachedProjectTasks(actor, projectId) {
  const entry = readAll(actor)[projectId];
  return entry && Array.isArray(entry.tasks) ? entry.tasks : null;
}
